export default "/images/iphoneSE.cb0322d2.jpg";